jQuery( 'body' ).ready( function ( $ ) {

  if ($(".taps-mobile-slick").length > 0) {
    $(".taps-mobile-slick").slick({
      responsive: [
        {
          breakpoint: 576,
          settings: {
            dots: true,
            arrows: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 4000,
            slidesToShow: 1,
            slidesToScroll: 1,
            rows: 1,
            vertical: false,
            verticalSwiping: false,
            adaptiveHeight: false,
          },
        },
      ],
    });
  }

  if ($(".cards-develop-cycle-mobile-slick").length > 0) {
    $(".cards-develop-cycle-mobile-slick").slick({
      responsive: [
        {
          breakpoint: 576,
          settings: {
            dots: true,
            arrows: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 4000,
            slidesToShow: 1,
            slidesToScroll: 1,
            rows: 1,
            vertical: false,
            verticalSwiping: false,
            adaptiveHeight: false,
          },
        },
      ],
    });
  }

  if ($(".slick-content-cross-platform-softFactory").length > 0) {
    $(".slick-content-cross-platform-softFactory").slick({
      infinite: true,
      autoplay: false,
      slidesToShow: 1,
      prevArrow: $(".expertise-icon-prev"),
      nextArrow: $(".expertise-icon-next"),
      responsive: [
        {
          breakpoint: 769,
          settings: {
            prevArrow: false,
            nextArrow: false,
            dots: true,
            arrows: false,
            infinite: true,
            autoplay: false,
            autoplaySpeed: 4000,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }

  if ( $( '.slick-slider-new-frame' ).length > 0 ) {
    $( '.slick-slider-new-frame' ).slick( {
      dots: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 4000,
      slidesToShow: 4,
      arrows: true,
      prevArrow: $(".slider-card-icon-prev"),
      nextArrow: $(".slider-card-icon-next"),
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            dots: true,
            arrows: false,
          },
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true,
            arrows: false,
          },
        },
        {
          breakpoint: 578,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
          },
        },
      ],
    } );
  }
});
